import { BACK_IN_STOCK_HANDLE, syncBackInStockSettings } from './extensions/back-in-stock/syncSettings';

// Extensions opt in here. Keep service-specific requests and acknowledgement
// checks in their own handlers, outside the shared Appmaker form.
const settingsSyncHandlers = new Map([
    [BACK_IN_STOCK_HANDLE, syncBackInStockSettings],
]);

const pendingOperations = new Map();

export const hasExtensionSettingsSync = handle => settingsSyncHandlers.has(handle);

// Serialize persistence AND its sync across forms, lifecycle controls and route
// remounts in this dashboard session. A failed operation must not block a retry.
export function runExtensionSettingsOperation(projectId, handle, operation) {
    if (!hasExtensionSettingsSync(handle)) return operation();
    const key = JSON.stringify([String(projectId), handle]);
    const previous = pendingOperations.get(key);
    let result;
    try {
        result = previous ? previous.then(operation) : Promise.resolve(operation());
    } catch (error) {
        result = Promise.reject(error);
    }
    const settled = result.then(() => {}, () => {});
    pendingOperations.set(key, settled);
    settled.then(() => {
        if (pendingOperations.get(key) === settled) pendingOperations.delete(key);
    });
    return result;
}

// Call only after persisting the installation. Handlers read the saved snapshot
// through their API; unsaved form data is deliberately not passed to them.
export async function syncExtensionSettings(projectId, handle, { failureMessage } = {}) {
    const sync = settingsSyncHandlers.get(handle);
    if (!sync) return;
    try {
        await sync(projectId, handle);
    } catch (error) {
        throw failureMessage ? new Error(failureMessage) : error;
    }
}
